import React from "react";
import Layout from "../components/Layout";

const CookiePolicy = () => {
    return (
        <Layout>
            <div className="bg-[#F9FAFB] min-h-screen pb-20">

                {/* Dark Banner Section */}
                <div className="bg-[#0B1120] text-white py-16 px-6 md:px-12 text-center flex flex-col items-center justify-center">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight">Cookie Policy</h1>
                    <p className="text-gray-400 text-sm md:text-base max-w-2xl leading-relaxed">
                        This Cookie Policy explains how and why we use cookies and similar technologies when you visit the uHyve platform.
                    </p>
                </div>

                {/* Two-Column Content Section */}
                <div className="max-w-7xl mx-auto px-6 mt-12 flex flex-col md:flex-row gap-12 relative">

                    {/* Left Column: Sticky Table of Contents */}
                    <div className="md:w-1/4 flex-shrink-0">
                        <div className="sticky top-32">
                            <h3 className="text-[14px] font-bold text-[#0B1120] uppercase tracking-wider mb-6">Legal</h3>
                            <ul className="space-y-4">
                                <li>
                                    <a href="/privacy-policy" className="text-[15px] text-gray-500 hover:text-[#0B1120] transition-colors border-l-2 border-transparent hover:border-gray-300 pl-3 py-1 block">
                                        Privacy Policy
                                    </a>
                                </li>
                                <li>
                                    <a href="/terms-of-service" className="text-[15px] text-gray-500 hover:text-[#0B1120] transition-colors border-l-2 border-transparent hover:border-gray-300 pl-3 py-1 block">
                                        Terms of Service
                                    </a>
                                </li>
                                <li>
                                    <a href="/cookie-policy" className="text-[15px] font-semibold text-[#7C3AED] hover:text-[#6D28D9] transition-colors border-l-2 border-[#7C3AED] pl-3 py-1 block">
                                        Cookie Policy
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Right Column: Main Content */}
                    <div className="md:w-3/4 bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-gray-100 mb-12">
                        <div className="prose prose-lg max-w-none text-[#0B1120]">

                            <div className="mb-8">
                                <p className="text-gray-500 text-sm font-semibold uppercase tracking-wider mb-2">Effective Date: October 1, 2023</p>
                                <p className="text-gray-600 leading-relaxed">
                                    This Cookie Policy explains how uHyve Inc. uses cookies and similar technologies to recognize you when you visit our website at uhyve.com or use our mobile application. It explains what these technologies are and why we use them, as well as your rights to control our use of them.
                                </p>
                            </div>

                            <hr className="border-gray-100 my-8" />

                            <div className="mb-10">
                                <h2 className="text-2xl font-bold mb-4">1. What are cookies?</h2>
                                <p className="text-gray-600 leading-relaxed mb-4">
                                    Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by online service providers in order to make their websites or services work, or to work more efficiently, as well as to provide reporting information.
                                </p>
                                <p className="text-gray-600 leading-relaxed">
                                    Cookies set by the website owner (in this case, uHyve) are called "first-party cookies". Cookies set by parties other than the website owner are called "third-party cookies". Third-party cookies enable third-party features or functionality to be provided on or through the website (e.g., like advertising, interactive content and analytics).
                                </p>
                            </div>

                            <div className="mb-10">
                                <h2 className="text-2xl font-bold mb-4">2. Why do we use cookies?</h2>
                                <p className="text-gray-600 leading-relaxed mb-4">
                                    We use first-party and third-party cookies for several reasons. Some cookies are required for technical reasons in order for our platform to operate, and we refer to these as "essential" or "strictly necessary" cookies. Other cookies also enable us to track and target the interests of our users to enhance the experience on our platform. Third parties serve cookies through our platform for analytics and other purposes.
                                </p>
                                <h3 className="text-lg font-semibold mb-2">A. Essential Cookies</h3>
                                <p className="text-gray-600 leading-relaxed mb-4">
                                    These cookies are strictly necessary to provide you with services available through our platform and to use some of its features, such as access to secure areas containing your booking history or payment management via Stripe.
                                </p>
                                <h3 className="text-lg font-semibold mb-2">B. Performance and Functionality Cookies</h3>
                                <p className="text-gray-600 leading-relaxed mb-4">
                                    These cookies are used to enhance the performance and functionality of our platform but are non-essential to their use. However, without these cookies, certain functionality (like remembering your login state or preferred language) may become unavailable.
                                </p>
                                <h3 className="text-lg font-semibold mb-2">C. Analytics and Customization Cookies</h3>
                                <p className="text-gray-600 leading-relaxed">
                                    These cookies collect information that is used either in aggregate form to help us understand how our platform is being used or how effective our marketing campaigns are, or to help us customize our platform for you to enhance your experience.
                                </p>
                            </div>

                            <div className="mb-10">
                                <h2 className="text-2xl font-bold mb-4">3. How can I control cookies?</h2>
                                <p className="text-gray-600 leading-relaxed mb-4">
                                    You have the right to decide whether to accept or reject cookies. You can set or amend your web browser controls to accept or refuse cookies. If you choose to reject cookies, you may still use our platform though your access to some functionality and areas of our platform may be restricted.
                                </p>
                                <p className="text-gray-600 leading-relaxed">
                                    As the means by which you can refuse cookies through your web browser controls vary from browser-to-browser, you should visit your browser's help menu for more information.
                                </p>
                            </div>

                            <div className="mb-10">
                                <h2 className="text-2xl font-bold mb-4">4. Updates to this Cookie Policy</h2>
                                <p className="text-gray-600 leading-relaxed">
                                    We may update this Cookie Policy from time to time in order to reflect, for example, changes to the cookies we use or for other operational, legal or regulatory reasons. Please therefore re-visit this Cookie Policy regularly to stay informed about our use of cookies and related technologies.
                                </p>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </Layout>
    );
};

export default CookiePolicy;
